import React, { useState } from 'react';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const AgentLoginPage = ({ onLogin }) => {
  const [form, setForm] = useState({ number: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await axios.post(`${API_BASE_URL}/agent-login`, form);
      if (res.data && res.data.agent) {
        localStorage.setItem('agent', JSON.stringify(res.data.agent));
        onLogin(res.data.agent); // Only navigate if login is successful
      } else {
        setError('Invalid credentials');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-900 to-indigo-700">
      <form className="bg-white rounded-lg shadow-lg p-8 w-96" onSubmit={handleSubmit} autoComplete="on">
        <h2 className="text-2xl font-bold mb-4">Agent Login</h2>
        <input
          name="number"
          id="number"
          type="tel"
          placeholder="Phone Number"
          autoComplete="username"
          className="border px-3 py-2 w-full mb-3"
          value={form.number}
          onChange={handleChange}
          required
          disabled={loading}
        />
        <input
          name="password"
          id="password"
          type="password"
          placeholder="Password"
          autoComplete="current-password"
          className="border px-3 py-2 w-full mb-3"
          value={form.password}
          onChange={handleChange}
          required
          disabled={loading}
        />
        <button
          className="bg-blue-600 text-white px-4 py-2 rounded w-full font-bold"
          type="submit"
          disabled={loading}
        >
          {loading ? 'Logging in...' : 'Login'}
        </button>
        {error && <div className="mt-3 text-red-600 text-sm">{error}</div>}
      </form>
    </div>
  );
};

export default AgentLoginPage;